import API from '@/utils/ApiConfig'
import { getAxios } from '@/utils/Utils'

const getUploadUrl = () => getAxios().get(API.SERVER + API.S3_UPLOAD_URL).then((res) => {
  const parts = res.data.data.url.split('?')[0].split('/')

  return {
    id: parts[(parts.length - 1)],
    url: res.data.data.url
  }
}).catch(err => { throw err })

const upload = (file) => {
  return getUploadUrl().then((uploadEndpointInfo) => {
    const config = {
      timeout: 100000,
      headers: {
        'Content-Type': file.type
      }
    }
    getAxios(config).put(uploadEndpointInfo.url, file, config)
    return fetch(uploadEndpointInfo.url, {
      method: 'PUT',
      headers: new Headers({'content-type': file.type}),
      body: file
    }).then((res) => uploadEndpointInfo.id)
  })
}

export default {
  getUploadUrl: getUploadUrl,
  upload: upload
}



// WEBPACK FOOTER //
// ./src/services/S3Service.js